import { menuIngredientCardFactory } from './chunk-OMAKIOP6.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuIngredientsTableFactory.ts
var menuIngredientsTableFactoryCore = (ingredients, items) => menuIngredientCardFactory(ingredients).map((ingredient) => {
  const menuIngredient = ingredients[ingredient.id];
  return __spreadProps(__spreadValues({}, ingredient), {
    is86ed: menuIngredient.is86ed,
    items: menuIngredient.itemIds.map((itemId) => items[itemId].name).join(", ") || void 0
  });
});

export { menuIngredientsTableFactoryCore };
